import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsExpenses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      expenses_data: props.expenses_data || null,
      has_split_jobs: props.has_split_jobs || null,
      expenses_approval_data: props.expense_approval_data || null,
      isLoadingExpensesInfo: true,
      downloadExpensesImagesForJobUrl: '/api/v1/portal/jobs/download-expenses-images',
      showAddExpenseForm: false,
      isMarkJobAsCheckedLoading:false,
      setJobAsReadyToBeInvoiceLoading:false
    };

    this.saveExpenseSettings = this.
    saveExpenseSettings.bind(this);
    this.handleAddExpenseFileConvert = this.
    handleAddExpenseFileConvert.bind(this);

    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'ExpensesInfoChanged',
      (e) => {
        this.getExpensesInfo();
      }
    );
  }

  componentDidMount() {
    this.getExpensesInfo();
  }

  getExpensesInfo() {
    let url = '/api/v1/portal/expenses-info/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((expensesInfoJson) => {
        this.setState({
          expenses_data: expensesInfoJson['expenses_data'],
          expense_approval_data: expensesInfoJson['expense_approval_data'],
          isLoadingExpensesInfo: false,
          has_split_jobs: expensesInfoJson['has_split_jobs'],
        })
      });
    });
  }

  toggleMarkJobAsChecked(e) {
    this.setState({isMarkJobAsCheckedLoading:true});  
    $.ajax({
      url: "/api/v1/portal/jobs/mark-as/toggle/checked/"+
        this.state.data.id,
      data: {
        api_token: window.api_token
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
      console.log(data);
      this.setState({isMarkJobAsCheckedLoading:false});  
    }.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  downloadExpensesImagesForJob(e, jobId) {
    return fetch(this.state.downloadExpensesImagesForJobUrl+'/'+jobId,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/zip'
        },
      }).then((responseText) => {
      let response = responseText.blob();
      response.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          jobId+'-expenses-images.zip'
        );
        document.body.appendChild(link);
        link.click();
      });
    });
  }

  setJobAsReadyToBeInvoiced() {
    this.setState({setJobAsReadyToBeInvoiceLoading:true});  
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
    }.bind(this));
  }
  setJobAsNotReadyToBeInvoiced() {
    this.setState({setJobAsReadyToBeInvoiceLoading:true});
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-not-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
    }.bind(this));
  }

  saveExpenseSettings(expenseName) {
    let jobId = this.state.data.id,
      expenseContainer = "[data-expense-name='"+expenseName+"']",
      expenseUploadcare = $(
        expenseContainer + " [name=uploadcare_image_url]"
      ).val(), 
      expenseDescription = $(
        expenseContainer + " [name=description]"
      ).val(),
      expenseCostInPence = $(
        expenseContainer + " [name=expense_cost_in_pence]"
      ).val() * 100,
      expenseApproved = $(
        expenseContainer + " label.active [name=expense_approved]"
      ).val(),
      expenseReason = $(
        expenseContainer + " [name=expense_reason]"
      ).val(),
//      expenseCustomerVatCode = $(
//        expenseContainer + " [name=expense_customer_vat_code]"
//      ).val(),
      expenseType = $(
        expenseContainer + " [name=expense_type]"
      ).val(),
      expenseVatCode = $(
        expenseContainer + " [name=expense_vat_code]"
      ).val(),
      expenseClientChargeInPence = $(
        expenseContainer + " [name=expense_client_charge]"
      ).val() * 100,
      expenseDriverPayInPence = $(
        expenseContainer + " [name=expense_driver_pay]"
      ).val() * 100;
    
    let successmsg = 'This expense has been ';
    successmsg += (expenseApproved == 1) ? 'approved.' : 'not approved.';
    $(expenseContainer).find('.save-settings-for-expense').prop("disabled", true);

        $.ajax({
          url: "/api/v1/portal/expense-approval/" + jobId,
          data: {
            api_token: window.api_token,
            expense_name: expenseName,
            expense_uploadcare_image_url: expenseUploadcare,
            expense_description: expenseDescription,
            expense_cost_in_pence: expenseCostInPence,
            expense_approved: expenseApproved,
            expense_reason: expenseReason,
            expense_type: expenseType,
            expense_vat_code: expenseVatCode,
            //expense_customer_vat_code: expenseCustomerVatCode,
            expense_client_charge_in_pence: expenseClientChargeInPence,
            expense_driver_pay_in_pence: expenseDriverPayInPence,
          },
          cache: false,
          method: 'post',
          dataType: "text/json",
          complete: function (response) {
            $(expenseContainer).find('.save-settings-for-expense').prop("disabled", false);
            if (response.status === 200) {
              $('#infomodallabel').html('Expense Settings Saved.');
              $('#infomodal .modal-body').html('Expense info updated.');
              $('#infomodal').modal();
              $(expenseContainer).find('.expense-approval-msg').html(successmsg);
              if(expenseApproved == 1 || expenseApproved == 0){
                  $(expenseContainer).find('.expense-form-radio-container').addClass('disabled');
              }
            } else {
              $('#infomodallabel').html('Error');
              $('#infomodal .modal-body').html(
              response.responseText.replace(/\"/g,
                "")
              );
              $('#infomodal').modal();
            }
          }
        });
  }

  handleAddExpenseFileConvert() {
    let jobId = this.state.data.id;
    let uploadInput = document.getElementById(
      'add-expense-expense-image-input-'+jobId
    );

    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById(
          "add-expense-expense-image-"+jobId
        ).src = e.target.result;
        document.getElementById(
          "add-expense-expense-image-b64-"+jobId
        ).value = e.target.result;
      });

      fileReader.readAsDataURL(uploadInput.files[0]);
    }
    else {
      alert('sorry, error working with image');
    }
  }

  addNewExpenseToJob(e) {
    e.preventDefault();
    let jobId = this.state.data.id;
    let newExpenseData= {
      api_token: window.api_token,

      expense_image: document.getElementById(
        "add-expense-expense-image-b64-"+jobId
      ).value,
      expense_type: document.getElementById(
        "add-expense-expense-type-"+jobId
      ).value,
      expense_cost: document.getElementById(
        "add-expense-expense-cost-"+jobId
      ).value,
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/jobs/add-new-expense/'+jobId,
      data: newExpenseData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          document.getElementById('infomodallabel').
            innerHTML = 'New Expense Uploaded to Job'
          document.querySelector('#infomodal .modal-body').
            innerHTML = 'Expense added successfully.';
          $('#infomodal').modal();
        }
        else {
          document.querySelector('#infomodallabel').
            innerHTML = 'Error adding new expense to job';

          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.
              replace(/\"/g, "")
            ));
          $('#infomodal').modal();
        }
      }
    });
  }

  renderExpensesInfoBlock() {
    let expensesInfoBlock;
    let Expenses = [];

    expensesInfoBlock = (
      <p><strong>No expenses have been uploaded from driver app.</strong></p>
    );

    if (!this.state.isLoadingExpensesInfo &&
         this.state.expenses_data &&
        (this.state.expenses_data.length > 0)) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }

      let expenseNum = 0;
      let self = this;
      let expense = '';
      let expenseApprovalSettings = {};
      let expenseApprovalSetting = {};
      let expenseApproved = '';
      let expenseNotApproved = '';
      let expenseDefaultValue = '';
      let expenseReason = '';
      let expenseType = '';
      let expenseVatCode = '';
      let expenseCustomerVatCode = '';
      let expensemsg = '';
      let expenseApproval='';
      let has_split_jobs = this.state.has_split_jobs;
      let json = '';
      let expense_jobID = '';
      
      this.state.expenses_data.forEach((i,index) =>{
        expense_jobID = (i.job_id != null) ? i.job_id+'-'+index : jobId+'-'+index;
        if(has_split_jobs === 1){
            json = JSON.parse(i.expenses_json.replace(/\\/g,''));
            
            json.forEach((i,index) =>{
                expense = (i.photo_name);
                expenseApprovalSettings = self.state.expense_approval_data;
                if (expense in expenseApprovalSettings) {
                  expenseApprovalSetting = expenseApprovalSettings[expense];
                  expenseApproved = '';
                  expenseNotApproved = '';
                  if (expenseApprovalSetting.approved === 1) {
                    expenseApproved = 'active';
                    expensemsg = 'This expense has been approved.';
                    expenseNotApproved = '';
                    expenseApproval = 'disabled';
                    expenseReason = expenseApprovalSetting.reason_for_approving;
                  }
                  else {
                    expenseApproved = '';
                    expenseNotApproved = 'active';
                    expensemsg = 'This expense has been not approved.';
                    expenseApproval = 'disabled';
                    expenseReason = expenseApprovalSetting.reason_for_not_approving;
                  }

                  expenseDefaultValue = (
                    expenseApprovalSetting.cost_in_pence/100
                  ).toFixed(2);
                  expenseType = expenseApprovalSetting.type;
                  expenseVatCode = expenseApprovalSetting.vat_code;
                  expenseCustomerVatCode = expenseApprovalSetting.customer_vat_code;
                }
                else {
                  expenseDefaultValue = (i.cost_in_pence/100).toFixed(2);
                  expenseApproved = '';
                  expenseNotApproved = '';
                  expenseReason = '';
                  expenseType = '';
                  expenseApproval = '';
                  expenseVatCode = '';
                  expenseCustomerVatCode = '';
                  expensemsg = '';
                  expenseApprovalSetting.driver_pay_in_pence = 0;
                  expenseApprovalSetting.client_charge_in_pence = 0;
                }
                expenseNum++;

                if (!expenseApprovalSetting.client_charge_in_pence) {
                  expenseApprovalSetting.client_charge_in_pence = 0;
                }

                if (!expenseApprovalSetting.driver_pay_in_pence) {
                  expenseApprovalSetting.driver_pay_in_pence = 0;
                }
                let appraisalExpenseImage;

                if(i.uploadcare_image_url)
                {
                  if(i.uploadcare_image_url.includes("https://")){
                    appraisalExpenseImage = <img
                            src={i.uploadcare_image_url
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/placeholders/driver-app.png"
                            }}
                          />;
                  }else{
                    appraisalExpenseImage = <img
                            src={
                              "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/placeholders/driver-app.png"
                            }}
                          />;
                  }
                }
                else
                {
                  appraisalExpenseImage = <img
                          src={
                            "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/placeholders/driver-app.png"
                          }}
                        />;
                }
                Expenses.push(
                  <div className="row job-expenses-row"
                       key={"jobs-table-row-"+jobId+"-expense-"+expenseNum}
                       data-expense-name={i.photo_name} data-expense-index={expense_jobID}>
                    <input type="hidden" value={i.description} name="description" />
					          <input type="hidden" value={i.uploadcare_image_url} name="uploadcare_image_url" />
                    <div className="col-md-4 expense-image-container">
                      <a href=""
                         className="pop"
                         id={"jobs-table-row-"+jobId+"-expense-image-"+expenseNum}>
                          {appraisalExpenseImage}
                      </a>
                      <div>{i.description}</div>
                    </div>
                    <div className="col-md-3 input-group expense-cost-container">
                      <div className="input-group-prepend">
                        <span className="input-group-text">&pound;</span>
                      </div>
                      <input name="expense_cost_in_pence" className="form-control"
                             defaultValue={expenseDefaultValue} />
                    </div>
                    <div className="col-md-5 jobs-table-expenses-column">
                      <div className="row expense-approved-and-reason-container">
                        <div className="col-md-12"><b className="expense-approval-msg">{expensemsg}</b></div>
                        <div className="col-md-4">
                          <p>
                            Approved?
                          </p>
                          <div
                            className={"btn-group btn-group-toggle expense-form-radio-container "+expenseApproval}
                            data-toggle="buttons">
                            <label
                              className={
                                "btn btn-secondary expense-approved "+expenseApproved
                              }
                            >
                              <input
                                className="form-control form-control-lg"
                                name="expense_approved"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={
                                "btn btn-secondary expense-not-approved "+
                                expenseNotApproved
                              }
                            >
                              <input
                                className="form-control form-control-lg"
                                name="expense_approved"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <p>
                            Reason
                          </p>
                          <textarea
                            name="expense_reason"
                            className="form-control form-control-lg"
                            defaultValue={expenseReason}>
                          </textarea>
                        </div>

                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <p>
                            Client Charge 
                          </p>
                          <div className="input-group">
                            <div
                              className="input-group-prepend input-group-prepend-alt"
                            >
                              <div
                                className="input-group-text input-group-text-alt"
                              >&pound;</div>
                            </div>
                            <input
                              className="form-control form-control-lg text-left"
                              name="expense_client_charge"
                              readOnly={(self.state.data && self.state.data.fuel_included_in_job_price) ?
                                  'readOnly'
                                  :
                                 false
                              }
                              type="text"
                              defaultValue={
                                (expenseApprovalSetting.client_charge_in_pence/100
                                ).toFixed(2)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <p>
                            Driver Pay
                          </p>
                          <div className="input-group">
                            <div
                              className="input-group-prepend input-group-prepend-alt"
                            >
                              <div
                                className="input-group-text input-group-text-alt"
                              >&pound;</div>
                            </div>
                            <input
                              className="form-control form-control-lg text-left"
                              name="expense_driver_pay"
                              type="text"
                              defaultValue={
                                (expenseApprovalSetting.driver_pay_in_pence/100
                                ).toFixed(2)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <p>
                            Expense Type
                          </p>
                          <div className="row expense-type-options">
                            <div className="col-md-7">
                              <select
                                name="expense_type"
                                className="form-control form-control-lg"
                                defaultValue={expenseType}
                              >
                                <option value="4001">Fuel Oil Adblue</option>
                                <option value="4000">Vehicle Movements</option>
                                <option value="4002">Toll Road</option>
                                <option value="4003">Waitingtime</option>
                                <option value="4004">Storage</option>
                                <option value="4005">Breakdown</option>
                                <option value="4006">Travel</option>
                                <option value="4007">Car Wash</option>
                                <option value="4008">Parts</option>
                                <option value="4009">Transport Services</option>
                                <option value="7402">Hotel</option>
                              </select>
                            </div>
                            <div className="col-md-5">
                              <select
                                name="expense_vat_code"
                                className="form-control form-control-lg"
                                defaultValue={expenseVatCode}
                              >
                                <option value="t1">VAT</option>
                                <option value="t0">No VAT</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="expense-save-settings-button-container">
                        <p>
                          <button
                            className="btn btn-lg btn-dark save-settings-for-expense"
                            onClick={() => {
                              self.saveExpenseSettings(i.photo_name)}}>
                            <i className="fa fa-save"></i>&nbsp;
                            Save settings for this expense
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                )
            });
        }else{
            expense = (i.photo_name);
            if(i.photo_name == null || i.photo_name == ""){
                expense = jobId+'_photo_name_'+index;
            }
            expenseApprovalSettings = self.state.expense_approval_data;
            if (expense in expenseApprovalSettings) {
              expenseApprovalSetting = expenseApprovalSettings[expense];
              expenseApproved = '';
              expenseNotApproved = '';
              if (expenseApprovalSetting.approved === 1) {
                expenseApproved = 'active';
                expensemsg = 'This expense has been approved.';
                expenseNotApproved = '';
                expenseApproval = 'disabled';
                expenseReason = expenseApprovalSetting.reason_for_approving;
              }
              else {
                expenseApproved = '';
                expenseNotApproved = 'active';
                expensemsg = 'This expense has been not approved.';
                expenseApproval = 'disabled';
                expenseReason = expenseApprovalSetting.reason_for_not_approving;
              }

              expenseDefaultValue = (
                expenseApprovalSetting.cost_in_pence/100
              ).toFixed(2);
              expenseType = expenseApprovalSetting.type;
              expenseVatCode = expenseApprovalSetting.vat_code;
              expenseCustomerVatCode = expenseApprovalSetting.customer_vat_code;

            }
            else {
              expenseDefaultValue = (i.cost_in_pence/100).toFixed(2);
              expenseApproved = '';
              expenseNotApproved = '';
              expenseReason = '';
              expenseType = '';
              expenseApproval = '';
              expenseVatCode = '';
              expenseCustomerVatCode = '';
              expensemsg = '';
              expenseApprovalSetting.driver_pay_in_pence = 0;
              expenseApprovalSetting.client_charge_in_pence = 0;
            }
            expenseNum++;

            if (!expenseApprovalSetting.client_charge_in_pence) {
              expenseApprovalSetting.client_charge_in_pence = 0;
            }

            if (!expenseApprovalSetting.driver_pay_in_pence) {
              expenseApprovalSetting.driver_pay_in_pence = 0;
            }
            let appraisalExpenseImage;

            if(i.uploadcare_image_url)
            {
              if(i.uploadcare_image_url.includes("https://")){
                appraisalExpenseImage = <img
                        src={i.uploadcare_image_url
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/placeholders/driver-app.png"
                        }}
                      />;
              }else{
                appraisalExpenseImage = <img
                        src={
                          "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/placeholders/driver-app.png"
                        }}
                      />;
              }
            }
            else
            {
              appraisalExpenseImage = <img
                      src={
                        "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/images/placeholders/driver-app.png"
                      }}
                    />;
            }
            Expenses.push(
              <div className="row job-expenses-row"
                   key={"jobs-table-row-"+jobId+"-expense-"+expenseNum}
                   data-expense-name={i.photo_name} data-expense-index={expense_jobID}>
                <input type="hidden" value={i.description} name="description" />
                <input type="hidden" value={i.uploadcare_image_url} name="uploadcare_image_url" />
                <div className="col-md-4 expense-image-container">
                  <a href=""
                     className="pop"
                     id={"jobs-table-row-"+jobId+"-expense-image-"+expenseNum}>
                      {appraisalExpenseImage}
                  </a>
                  <div>{i.description}</div>
                </div>
                <div className="col-md-3 input-group expense-cost-container">
                  <div className="input-group-prepend">
                    <span className="input-group-text">&pound;</span>
                  </div>
                  <input name="expense_cost_in_pence" className="form-control"
                         defaultValue={expenseDefaultValue} />
                </div>
                <div className="col-md-5 jobs-table-expenses-column">
                  <div className="row expense-approved-and-reason-container">
                    <div className="col-md-12"><b className="expense-approval-msg">{expensemsg}</b></div>
                    <div className="col-md-4">
                      <p>
                        Approved?
                      </p>
                      <div
                        className={"btn-group btn-group-toggle expense-form-radio-container "+expenseApproval}
                        data-toggle="buttons">
                        <label
                          className={
                            "btn btn-secondary expense-approved "+expenseApproved
                          }
                        >
                          <input
                            className="form-control form-control-lg"
                            name="expense_approved"
                            type="radio"
                            value="1"
                            required
                          /> YES
                        </label>
                        <label
                          className={
                            "btn btn-secondary expense-not-approved "+
                            expenseNotApproved
                          }
                        >
                          <input
                            className="form-control form-control-lg"
                            name="expense_approved"
                            type="radio"
                            value="0"
                            required
                          /> NO
                        </label>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        Reason
                      </p>
                      <textarea
                        name="expense_reason"
                        className="form-control form-control-lg"
                        defaultValue={expenseReason}>
                      </textarea>
                    </div>

                  </div>
                  <div className="row">
                  <div className="col-md-6">
                      <p>
                        Client Charge
                      </p>
                      <div className="input-group">
                        <div
                          className="input-group-prepend input-group-prepend-alt"
                        >
                          <div
                            className="input-group-text input-group-text-alt"
                          >&pound;</div>
                        </div>
                        <input
                            className="form-control form-control-lg text-left"
                            name="expense_client_charge"
                            readOnly={(self.state.data && self.state.data.fuel_included_in_job_price) ?
                                'readOnly'
                                :
                               false
                            }
                            type="text"
                            defaultValue={
                              (expenseApprovalSetting.client_charge_in_pence/100
                              ).toFixed(2)
                            }
                          />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <p>
                        Driver Pay
                      </p>
                      <div className="input-group">
                        <div
                          className="input-group-prepend input-group-prepend-alt"
                        >
                          <div
                            className="input-group-text input-group-text-alt"
                          >&pound;</div>
                        </div>
                        <input
                          className="form-control form-control-lg text-left"
                          name="expense_driver_pay"
                          type="text"
                          defaultValue={
                            (expenseApprovalSetting.driver_pay_in_pence/100
                            ).toFixed(2)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p>
                        Expense Type
                      </p>
                      <div className="row expense-type-options">
                        <div className="col-md-7">
                          <select
                            name="expense_type"
                            className="form-control form-control-lg"
                            defaultValue={expenseType}
                          >
                            <option value="4001">Fuel Oil Adblue</option>
                            <option value="4000">Vehicle Movements</option>
                            <option value="4002">Toll Road</option>
                            <option value="4003">Waitingtime</option>
                            <option value="4004">Storage</option>
                            <option value="4005">Breakdown</option>
                            <option value="4006">Travel</option>
                            <option value="4007">Car Wash</option>
                            <option value="4008">Parts</option>
                            <option value="4009">Transport Services</option>
                            <option value="7402">Hotel</option>
                          </select>
                        </div>
                        <div className="col-md-5">
                          <select
                            name="expense_vat_code"
                            className="form-control form-control-lg"
                            defaultValue={expenseVatCode}
                          >
                            <option value="t1">VAT</option>
                            <option value="t0">No VAT</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="expense-save-settings-button-container">
                    <p>
                      <button
                        className="btn btn-lg btn-dark save-settings-for-expense"
                        onClick={() => {
                          self.saveExpenseSettings(i.photo_name)}}>
                        <i className="fa fa-save"></i>&nbsp;
                        Save settings for this expense
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            )
        }
        
      });
      expensesInfoBlock = (
        <div>
          <div className="job-expenses-row"></div>
          {Expenses}
        </div>
      );
    }
    return expensesInfoBlock;
  }
  render() {
    return (
      <div>
        {this.state.isLoadingExpensesInfo ?
          <div className="loading-box">
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
          </div>
          :
          <div>
            <div className="row">
              <div className="col-md-12">
                {this.state.data.fuel_included_in_job_price === 1 ?
                  <strong>Fuel Included in Job Price</strong>
                  :
                  <strong>Fuel Not Included in Job Price</strong>
                }
                <div>
                  <a href="#"
                     onClick={(e) => {
                       this.downloadExpensesImagesForJob(
                         e,
                         this.state.data.id
                       )
                     }}
                     className="btn btn-lg btn-success appraisal-download-button">
                    <i className="fa fa-download"></i> Download Expenses Images as .zip
                  </a>
                  {this.renderExpensesInfoBlock()}
                </div>
              </div>
            </div>
            <button className="btn btn-lg"
                    onClick={(e) => {
                      this.setState({
                        showAddExpenseForm: !this.state.showAddExpenseForm
                      });
                    }
                    }
            >
              <i className="fa fa-plus"></i> Add New Expense
            </button>
            {(this.state.showAddExpenseForm) ?
              <div
                className="row"
                id={
                  'add-expense-to-job-' +
                  this.state.data.id
                }
              >
                <div className="col-md-12">
                  <h4>Add Expense</h4>
                  <p>
                    Expense Type:<br/>
                    <input
                      type="text"
                      name="add_expense_expense_type"
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-type-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <p>
                    Cost:<br/>
                    <input
                      type="text"
                      name="add_expense_expense_cost"
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-cost-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <div className="form-group image-upload-container">
                    <label htmlFor="portal_account_photo">
                      Expense Image
                    </label>
                    <input
                      type='file'
                      onChange={
                        this.handleAddExpenseFileConvert
                      }
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-image-input-" +
                        this.state.data.id
                      }
                    />
                    <input
                      type="hidden"
                      name="image-base-64"
                      id={
                        "add-expense-expense-image-b64-" +
                        this.state.data.id
                      }
                    />
                  </div>
                  <p>
                    <img
                      id={
                        "add-expense-expense-image-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <p>
                    <button
                      className="btn btn-lg btn-success"
                      onClick={(e) => {
                        this.addNewExpenseToJob(e)
                      }}
                    >
                      <i className="fa fa-plus"></i>&nbsp;
                      Add New Expense
                    </button>
                  </p>
                </div>
              </div>
              :
              ''
            }
            <div className="text-right">
              {( (this.state.data.checked === 1) &&
                (this.state.data.checked_by) &&
                (this.state.data.checked_by.first_name)) ?
                <p>
                  <button className="btn btn-lg btn-success">
                    Job Checked (by {this.state.data.checked_by.first_name
                  }&nbsp;{this.state.data.checked_by.last_name} on {
                    this.state.data.checked_at
                  })
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-lg btn-dark job-row-highlighter-option-green"
                    title={"Toggle Mark Job as: JOB IS READY TO SEND" +
                    "TO DRIVER OR OUTSOURCED"}
                    onClick={(e) => this.toggleMarkJobAsChecked(e)}
                    disabled={(this.state.isMarkJobAsCheckedLoading) ? 'disabled':''}
                  >
                    <i className="fa fa-undo"></i>&nbsp;
                    Unmark Job As Checked
                  </button>
                </p>
                :
                <p>Job Not Checked<br/>
                  <button
                    className="btn btn-lg btn-dark job-row-highlighter-option-green"
                    title={"Toggle Mark Job as: JOB IS READY TO SEND" +
                    "TO DRIVER OR OUTSOURCED"}
                    onClick={(e) => this.toggleMarkJobAsChecked(e)}
                    disabled={(this.state.isMarkJobAsCheckedLoading) ? 'disabled':''}
                  >
                    Mark Job As Checked
                  </button>
                </p>

              }
            </div>
            {(this.state.data.ready_for_invoice === 1) ?
              <div className="text-right">
                <p>
                  <strong>Job ready to be invoiced</strong>
                </p>
                <p>
                  <button
                    className="btn btn-lg btn-warning"
                    disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? 'disabled':''}
                    onClick={() => {
                      this.setJobAsNotReadyToBeInvoiced(
                        this.state.data.id
                      )
                    }}>
                    Set Job as not ready to be invoiced
                  </button>
                </p>
              </div>
              :
              <div className="text-right">
                <p>
                  <strong>Job not ready to be invoiced</strong>
                </p>
                <p>
                  <button
                    className="btn btn-lg btn-primary"
                    disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? 'disabled':''}
                    onClick={() => {
                      this.setJobAsReadyToBeInvoiced(
                        this.state.data.id
                      )
                    }}>
                    Set Job as ready to be invoiced
                  </button>
                </p>
              </div>
            }
          </div>

        }
      </div>
    );
  }
}